import React, { Component } from "react";

const toIntl = (phone) => "40" + phone.replace(/\s/g, "").replace(/^0/, "");

class Servicii extends Component {
  render() {
    if (!this.props.data) return null;

    const serviciu = this.props.data.serviciu.map((item, index) => (
      <div key={`serviciu-${index}`}>
        <h3>{item.serv}</h3>
        <p>{item.descriere}</p>
        {item.phone && (
          <p className="serviciu-contact">
            <a className="serviciu-tel" href={"tel:+" + toIntl(item.phone)}>
              <i className="fa-solid fa-phone"></i>{" " + item.phone}
            </a>
            <a
              className="serviciu-whatsapp"
              href={"https://wa.me/" + toIntl(item.phone) + "?text=Buna%20ziua"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-whatsapp"></i> WhatsApp
            </a>
          </p>
        )}
      </div>
    ));

    const detailing = this.props.data.detailing.map((item, index) => (
      <div key={`detailing-${index}`}>
        <h3>{item.munk}</h3>
        <p>{item.descriere}</p>
      </div>
    ));

    return (
      <section id="resume">
        <div className="row education">
          <div className="three columns header-col">
            <h2>
              <span>Servicii</span>
            </h2>
          </div>

          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">{serviciu}</div>
            </div>
          </div>
        </div>

        <div className="row work">
          <div className="three columns header-col">
            <h2>
              <span>Detailing Auto</span>
            </h2>
          </div>

          <div className="nine columns main-col">{detailing}</div>
        </div>
      </section>
    );
  }
}

export default Servicii;
